module.exports = __webpack_public_path__ + "img/canvas-frame-md.30b612a.svg";